import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/index';
import { Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class PurchaeService extends BaseService {

  subject = new Subject<any>();

  send(message: any) {
    this.subject.next(message);
  }

  get(): Observable<any> {
    return this.subject.asObservable();
  }

  private url = 'api/article';

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

  //获取公告数量
  getNotice(params): Observable<any> {
    let url = this.getUrl();
    if (params.categoryId) {
      url = this.getUrl() + '?propertyNames=category.id&propertyValues=' + params.categoryId;
    }
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params,
      },
    ).pipe(
      tap(() => this.log('getNotice')),
      catchError(this.handleError('getNotice')),
    );
  }
  //获取公告数量
  getNotice1(pageRules): Observable<any> {
    // if (params.categoryId) {
    //   url = this.getUrl() + '?propertyNames=category.id&propertyValues=' + params.categoryId;
    // }
    return this.http.post<any>(this.getUrl()+'/page' , pageRules).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );



  }


  // 列表所需数据
  getUpcoming(stageld): Observable<any> {
    const url = `api/config-menu/find-by-code?code=${stageld}`;
    const code = stageld;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`api/config-menu`)),
      catchError(this.handleError<any>(`api/config-menu`)),
    );
  }

  // 消息数量
  getBasic(): Observable<any> {
    const url = `api/info-status/get-unread-count`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log('get-unread-count')),
      catchError(this.handleError<any>('get-unread-count')),
    );
  }

  // 获取人员信息
  userInfo(): Observable<any> {
    const url = `api/person/current`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log('current')),
      catchError(this.handleError<any>('current')),
    );
  }


  leaveMessage(type): Observable<any> {
    const url = `api/leave-message/${type}/pending`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log('leave-message')),
      catchError(this.handleError<any>('leave-message')),
    );
  }


  getChartData(): Observable<any> {
    const url = `api/config-menu/getChartData`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`api/config-menu`)),
      catchError(this.handleError<any>(`api/config-menu`)),
    );
  }

}
